// Utils
import { getObjectId } from '../objectIdentity';
/**
 * Describes whether two objects are the same object, either literally or as identified by their
 * object id.
 *
 * @param values1 {Identifiable<object>}
 * @param values2 {Identifiable<object>}
 *
 * @return {boolean}
 */
export var isSameObject = function (values1, values2) {
    if (values1 === values2) {
        return true;
    }
    var objectId1 = getObjectId(values1);
    var objectId2 = getObjectId(values2);
    if (objectId1 === null
        || objectId2 === null) {
        return false;
    }
    return objectId1 === objectId2;
};
//# sourceMappingURL=isSameObject.js.map